import { DecryptedPropertyStub, DecryptedTypedValue, PropertyTypeStub, TypedValuesType } from '@icure/cardinal-sdk'

export const getDecryptedPropertyStub = (identifier: string, value: string) => {
  return new DecryptedPropertyStub({
    type: new PropertyTypeStub({ identifier: identifier, type: TypedValuesType.String }),
    typedValue: new DecryptedTypedValue({
      type: TypedValuesType.String,
      stringValue: value,
    }),
  })
}

// Read: matches the new (type.identifier) OR legacy (id) format.
export const findProperty = (properties: DecryptedPropertyStub[] | undefined, identifier: string): DecryptedPropertyStub | undefined =>
  properties?.find((p) => p.type?.identifier === identifier || p.id === identifier)

export const findPropertyValue = (properties: DecryptedPropertyStub[] | undefined, identifier: string): string | undefined =>
  findProperty(properties, identifier)?.typedValue?.stringValue

// A matched property is legacy when it exists but carries no type.identifier.
export const isLegacyProperty = (prop: DecryptedPropertyStub | undefined): boolean => !!prop && !prop.type?.identifier

// Write: drop any entry matching the identifier (either format), append the new-format one.
export const withUpsertedProperty = (properties: DecryptedPropertyStub[] | undefined, identifier: string, value: string): DecryptedPropertyStub[] => [
  ...(properties ?? []).filter((p) => p.type?.identifier !== identifier && p.id !== identifier),
  getDecryptedPropertyStub(identifier, value),
]
